import {Component, ViewChild} from '@angular/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef,
  MatTable, MatTableDataSource
} from '@angular/material/table';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import { MatSort, MatSortModule } from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {MatTab, MatTabGroup} from '@angular/material/tabs';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from '../../shared/services/api';
import {LoaderService} from '../../shared/services/loader';
import {finalize} from 'rxjs';
import {User, UserListResponse} from '../../shared/types/customers.model';
import {MatFormField, MatInput, MatLabel, MatPrefix} from '@angular/material/input';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-users',
  imports: [
    MatTable,
    MatIcon,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatIconButton,
    MatCellDef,
    MatHeaderCellDef,
    MatHeaderRow,
    MatRow,
    MatSort,
    MatRowDef,
    MatHeaderRowDef,
    MatSortModule,
    MatPaginator,
    MatTabGroup,
    MatTab,
    MatFormField,
    MatInput,
    MatLabel,
    MatPrefix,
    DatePipe,
  ],
  templateUrl: './users.html',
  styleUrl: './users.css',
})
export class Users {

  dataSource = new MatTableDataSource<User>();
  originalSource  = new MatTableDataSource<User>();
  totalCount = 0;
  pageSize = 5;
  selectedTabIndex = 0;

  @ViewChild(MatSort, { static: true })
  sort!: MatSort;

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  displayedColumns: string[] = ['srNo', 'userName', 'contactNo', 'city', 'lastSession','vehicles','status', 'actions'];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private loader: LoaderService
  ) {}

  ngOnInit(): void {
    this.loader.start();
    this.loadCustomers(1, this.pageSize);

  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.paginator.page.subscribe(() => {
      const page = this.paginator.pageIndex +1;
      const limit = this.paginator.pageSize;
      this.loadCustomers(page, limit);
      this.dataSource.sort = this.sort;
    });

  }
  onTabChange(index: number) {
    this.selectedTabIndex = index;
    // this.applyFilter();
  }
  // applyFilter() {
  //   let filteredData: User[] = [];
  //   this.dataSource.data = this.originalSource.data;
  //
  //   switch (this.selectedTabIndex) {
  //     case 0:
  //       filteredData = this.dataSource.data;
  //       break;
  //     case 1:
  //       filteredData = this.dataSource.data.filter(u => u.approved > 0);
  //       break;
  //     case 2:
  //       filteredData = this.dataSource.data.filter(u => u.pending > 0);
  //       break;
  //     case 3:
  //       filteredData = this.dataSource.data.filter(u => u.rejected > 0);
  //       break;
  //   }
  //   this.dataSource.data = filteredData;
  //
  // }


  protected openUserDetails(id: string): void {
    this.router.navigate(['../users', id], {
      relativeTo: this.route,
    }).then(()=>{
      console.log("Navigate to User details Page");
    });
  }

  loadCustomers(page: number, limit: number) {
    this.loader.start();

    this.apiService.getCustomers(page, limit)
      .pipe(finalize(() => this.loader.stop()))
      .subscribe({
        next: (res: UserListResponse) => {
          this.dataSource.data= res.data;
          this.totalCount = res.meta.total;
        },
        error: (err) => {
          console.error('Failed to get users', err);
        }
      });
  }
}
